import clients from './mock-data/MockClients.json'
import {
    deepClone,
    arrayToBackEndFormat,
    arrayToFrontEndFormat,
    objectToFrontEndFormat,
    objectToBackendFormat,
} from '@/services/ObjectFormatter'
import { removeRUTHyphen, addRUTHyphen } from '@/services/RUTFormatter'
import responseFormat from './json_formats/CustomerFormat'
import CustomerModel from '../../models/Sale/SlCustomer'

const formatKeyObject = keyObj => {
    if(keyObj.field === 'rut') keyObj.value = addRUTHyphen(keyObj.value)
    return keyObj
}

const get = function(filtersArray) {
    filtersArray = arrayToBackEndFormat(filtersArray, responseFormat)
    let data = deepClone(clients.data)
    let response = data.filter(client => {
        let found = null
        filtersArray.forEach(filter => {
            if (filter.field == 'rut') filter.value = addRUTHyphen(filter.value)
            if (client[filter.field] === filter.value) found = client
        })
        return found != null
    })
    if (response.length > 0) {
        return arrayToFrontEndFormat(response, responseFormat)
    }
    return null
}

const findByKey = async uniqueKey => {
    uniqueKey = formatKeyObject(uniqueKey)
    //Must use axios because we are using a custom endpoint for rut filtering
    let object = await CustomerModel.where(
        uniqueKey.field,
        uniqueKey.value
    )
    .params({check_core_business:true})
    .include(['g_core_business_sii','main_core_business_sii'])
    .first()
    return fillCustomer({...object})
}

const fillCustomer= function(slCustumer){
    return {
        id : slCustumer.id,
        rut: slCustumer.rut ,
        businessName: slCustumer.business_name,
        personName : slCustumer.alias_name,
        coreBusiness : slCustumer.core_business,
        addres : slCustumer.address,
        phone: slCustumer.phone,
        email: slCustumer.email,
        comuna: 'definir_back' ,
        gCoreBusinessSii: (slCustumer.g_core_business_sii !== undefined) ? slCustumer.g_core_business_sii : [],
        mainGCoreBusiness_sii_id: (slCustumer.main_g_core_business_sii_id !== undefined) ? slCustumer.main_g_core_business_sii_id : null,
    }
}

const submitCustomer = async function (slCustomer){
    try{
        let newCustomer = new CustomerModel ({...slCustomer})
        let response = await newCustomer.save()
        return response 
    }
    catch(error){
        return error.response.data
    }
}

const findById = async id => {
    //Must use axios because we are using a custom endpoint for rut filtering
    let object = await CustomerModel
    .params({check_core_business:true})
    .include(['g_core_business_sii','main_core_business_sii'])
    .find(id)
    
    return fillCustomer(object)
}


export default {
    get,
    findByKey,
    submitCustomer,
    findById,
}
